export const removeExpecialCharactersFromCPF = (value: string) => {
  let formatValue = value.replace(/[.-]/g, '')
  formatValue = formatValue.replace(/\s+/g, '')

  return formatValue
}

function matchNumbers(value: string | number | number[]) {
  if (typeof value === 'string') {
    return (value.match(/\d/g) || []).map(Number)
  } else if (typeof value === 'number') {
    return value.toString().match(/\d/g)?.map(Number) || []
  } else if (Array.isArray(value)) {
    return value.filter((v) => typeof v === 'number' && v >= 0 && v <= 9)
  }
  return []
}

function validCalc(base: number, numbers: number[]) {
  const factors = Array.from({ length: base }, (_, i) => base + 1 - i)
  const sum = numbers.slice(0, base).reduce((acc, num, i) => acc + num * factors[i], 0)
  const result = (sum * 10) % 11
  return result === 10 ? 0 : result
}

export function isValidCPF(value: string | number | number[] = '') {
  if (!value) return false

  const isString = typeof value === 'string'
  const validTypes = isString || Number.isInteger(value) || Array.isArray(value)

  if (!validTypes) return false

  const numbers = matchNumbers(value)

  if (numbers.length !== 11) return false

  const items = [...new Set(numbers)]
  if (items.length === 1) return false

  const digits = numbers.slice(9)

  const digit0 = validCalc(9, numbers)
  if (digit0 !== digits[0]) return false

  const digit1 = validCalc(10, numbers)
  return digit1 === digits[1]
}

export function formatCPF(value: string | number | number[] = '', validate: boolean = true) {
  const numbers = matchNumbers(value)

  // Se tiver 12 dígitos, remover o último dígito
  if (numbers.length === 12) {
    numbers.pop()
  }

  // Verifica se o valor é válido
  const valid = isValidCPF(numbers)

  if (!valid && validate) {
    console.error(`CPF inválido: ${value}`)
    // Retorna um CPF formatado com "xxx"
    return 'xxx.xxx.xxx-xx'
  }

  const text = numbers.join('')

  const format = text.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')

  return format
}

export const cpfMask = (value: string) => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1')
}

export function rgMask(value: string) {
  return value
    .replace(/\D/g, '')
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3-$4');
}

export function cepMask(value: string) {
  return value
    .replace(/\D/g, '')
    .replace(/^(\d{5})(\d)/, '$1-$2');
}